<div class="consumer-layout">
  <div class="consumer-layout__topbar">
    <div class="consumer-layout__container consumer-layout__topbar-inner">
      <div class="consumer-layout__topbar-contacts">
        <span class="consumer-layout__topbar-item">
          <app-icon name="phone" [size]="14" />
          <span>{{ contactPhone() }}</span>
        </span>
        <span class="consumer-layout__topbar-item">
          <span>{{ contactEmail() }}</span>
        </span>
      </div>
      <div class="consumer-layout__topbar-links">
        <a href="#">About Us</a>
        <a href="#">Help</a>
        <a href="#">Install App</a>
      </div>
    </div>
  </div>

  <header class="consumer-layout__header">
    <div class="consumer-layout__container consumer-layout__header-inner">
      <a routerLink="/" class="consumer-layout__brand">
        @if (logoUrl()) {
          <img class="consumer-layout__logo" [src]="logoUrl()" [alt]="operatorName()" />
        } @else {
          <div class="consumer-layout__logo-fallback">{{ operatorInitials() }}</div>
        }
        <span class="consumer-layout__brand-name">{{ operatorName() }}</span>
      </a>

      <nav class="consumer-layout__nav">
        @for (item of navItems; track item) {
          <a
            [routerLink]="item === 'My Trips' ? '/my-trips' : '/'"
            routerLinkActive="consumer-layout__nav-link--active"
            [routerLinkActiveOptions]="{ exact: true }"
            class="consumer-layout__nav-link"
          >
            {{ item }}
            @if (item === 'Travel Info') {
              <app-icon name="chevron-down" [size]="14" />
            }
          </a>
        }
      </nav>

      @if (isAuthenticated()) {
        <div class="consumer-layout__account">
          <span class="consumer-layout__account-email" title="{{ userEmail() }}">
            {{ userEmail() }}
          </span>
          <button type="button" class="consumer-layout__login" (click)="logout()">
            Log Out
          </button>
        </div>
      } @else {
        <a routerLink="/auth" class="consumer-layout__login">Log In</a>
      }

      <button
        type="button"
        class="consumer-layout__burger"
        [attr.aria-expanded]="menuOpen()"
        aria-label="Toggle menu"
        (click)="toggleMenu()"
      >
        <app-icon [name]="menuOpen() ? 'x' : 'menu'" [size]="24" />
      </button>
    </div>

    @if (menuOpen()) {
      <nav class="consumer-layout__container consumer-layout__mobile-nav">
        @for (item of navItems; track item) {
          <a
            [routerLink]="item === 'My Trips' ? '/my-trips' : '/'"
            routerLinkActive="consumer-layout__mobile-link--active"
            [routerLinkActiveOptions]="{ exact: true }"
            class="consumer-layout__mobile-link"
            (click)="closeMenu()"
          >
            {{ item }}
          </a>
        }

        @if (isAuthenticated()) {
          <span class="consumer-layout__mobile-email">{{ userEmail() }}</span>
          <button
            type="button"
            class="consumer-layout__mobile-link consumer-layout__mobile-link--action"
            (click)="logout()"
          >
            Log Out
          </button>
        } @else {
          <a
            routerLink="/auth"
            class="consumer-layout__mobile-link consumer-layout__mobile-link--action"
            (click)="closeMenu()"
          >
            Log In
          </a>
        }
      </nav>
    }
  </header>

  <main class="consumer-layout__main">
    <router-outlet />
  </main>

  <footer class="consumer-layout__footer">
    <div class="consumer-layout__container consumer-layout__footer-grid">
      <div class="consumer-layout__footer-brand">
        @if (logoUrl()) {
          <img class="consumer-layout__footer-logo" [src]="logoUrl()" [alt]="operatorName()" />
        } @else {
          <div class="consumer-layout__logo-fallback consumer-layout__logo-fallback--footer">
            {{ operatorInitials() }}
          </div>
        }
        <p class="consumer-layout__footer-about">
          Book your bus trips across the Philippines with {{ operatorName() }}. Safe, reliable, and
          comfortable travel.
        </p>
      </div>

      <div>
        <h3 class="consumer-layout__footer-title">Quick Links</h3>
        <ul class="consumer-layout__footer-list">
          @for (link of footerLinks; track link) {
            <li><a href="#">{{ link }}</a></li>
          }
        </ul>
      </div>

      <div>
        <h3 class="consumer-layout__footer-title">Contact</h3>
        <ul class="consumer-layout__footer-list">
          <li>Hotline: {{ contactPhone() }}</li>
          <li>Email: {{ contactEmail() }}</li>
          <li>Terminal: {{ terminalLabel() }}</li>
        </ul>
      </div>
    </div>

    <div class="consumer-layout__container consumer-layout__footer-bottom">
      <p>&copy; 2026 {{ operatorName() }}. All rights reserved.</p>
    </div>
  </footer>
</div>
